module.exports = __webpack_public_path__ + "img/login-logo.c7ef016.png";